import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { checkWidgetAuthorization } from './utils/check-auth';

export const PublicRoute = ({ component: Component, store, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const access = checkWidgetAuthorization(store, rest);
      if (access.access) {
        if (access.role.includes('ROLE_USER')) {
          if (props.location.pathname.includes('software-development-cost-calculator')) {
            return <Component {...props} />;
          } else {
            return <Redirect to={{ pathname: '/dashboard', state: { from: props.location } }} />;
          }
        }
        return <Redirect to={{ pathname: '/', state: { from: props.location } }} />;
      } else {
        return <Component {...props} />;
      }
    }}
  />
);
